<template>
    <fragment>
        <template v-for="(item) in subMenuList">
            <el-submenu v-if="item.children && item.children.length>0" :index="item.path" :key="item.path">
                <template slot="title">
                    <i :class="'el-icon- iconfont icon'+item.meta.icon"></i>
                    <!--<i :class="'el-icon-'+item.icon"></i>-->
                    <span slot="title">{{item.meta.title}}</span>
                </template>
                <SubMenu :subMenuList="item.children"></SubMenu>
            </el-submenu>
            <el-menu-item v-else @click="clickMenu(item)" :index="item.path" :key="item.path">
                <i :class="'el-icon- iconfont icon'+item.meta.icon"></i>
                <!--<i :class="'el-icon-'+item.icon"></i>-->
                <span slot="title">{{item.meta.title}}</span>
            </el-menu-item>
        </template>
    </fragment>
</template>

<script>
    import bus from '@/utils/eventBus'

    export default {
        name: 'SubMenu',
        props: {
            subMenuList:{
                type: Array,
                default: function () {
                    return []
                }
            },
            tag:{
                type: String,
                default: '0'
            },
            pid:{
                type: Number,
                default: null
            }
        },
        data() {
            return {

            }
        },
        methods: {
            clickMenu (item) {
                if(this.tag==='1') {
                    //console.log(item)
                    this.$router.push({ path: item.path,query:{pid:this.pid} })
                    //this.$router.push(item.path)
                }
                // console.log('item',item)
                if(this.tag!='1') {
                    // console.log('tag非1',this.tag)
                    this.$router.push({ name: item.meta.title })
                    bus.$emit('share', {name: item.name,label: item.meta.title})
                }
            }
        }
    }
</script>

<style lang="scss" >
    /*.el-menu-vertical-demo:not(.el-menu--collapse) {
        width: 180px;
        min-height: 400px;
    }
    .el-submenu,.el-menu-item {

    }*/
    .el-menu-vertical-demo {
        height: 100%
    }
    .el-menu-item.is-active{
        background-color: #FFDA4B!important;
    }
</style>
